/**
 * @generated SignedSource<<4d72be817d2595e191ccfe82a129a2d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTotals_buyer$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutHelpers_buyer" | "clientAbTestV2_useAbTestV2BuyerUser_user">;
  readonly " $fragmentType": "CheckoutTotals_buyer";
};
export type CheckoutTotals_buyer$key = {
  readonly " $data"?: CheckoutTotals_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTotals_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTotals_buyer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "isVerifiedTrade",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_NET_PRICE"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"B_NET_PRICE\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "clientAbTestV2_useAbTestV2BuyerUser_user"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutHelpers_buyer",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AddressBook",
          "kind": "LinkedField",
          "name": "addressBook",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Address",
              "kind": "LinkedField",
              "name": "addressList",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "state",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayState",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "3351a1d4bf1b53cbc9bc0fcc86f38a25";

export default node;
